import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as constants from '../constants'
import type { Plugin } from '../plugin'

/**
 * Sets a target-scoped current organization ID.
 */
export const setCurrentEntityTarget = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.setCurrentEntityTarget.relay((forwardTo, { id }) =>
      rxjs.of(
        forwardTo(
          plugin.collection.plugins.currentEntityPlugin.storage.actions
            .putInIdLookup,
          {
            input: {
              key: constants.CURRENT_ENTITY_TARGET,
              value: id,
            },
          },
        ),
      ),
    ).asObservable,
)
